import { LogLevel } from 'features/analytics/enums';
import {
  sendAnalyticsError,
  sendAnalyticsInfo,
  sendAnalyticsWarning,
} from 'features/analytics/helpers';

interface notificationErrorAnalyticsType {
  methodName: string;
  error: string;
  state?: any;
  message?: string;
  level?: LogLevel;
}

export const notificationErrorAnalytics = ({
  methodName,
  error,
  state,
  message,
  level = LogLevel.ERROR,
}: notificationErrorAnalyticsType) => {
  const payload = {
    Method: methodName,
    Message: message,
    Error: error,
    state: state,
  };

  switch (level) {
    case LogLevel.WARNING:
      return sendAnalyticsWarning(payload);
    case LogLevel.INFO:
      return sendAnalyticsInfo(payload);
    case LogLevel.ERROR:
      return sendAnalyticsError(payload);
    default: {
      const _exhaustive: never = level;
      return _exhaustive;
    }
  }
};
